// Generated by scripts/update-seeq-icons.js from src/svg/seeq/skill-explorer.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcSkillExplorer = {
  prefix: 'fak',
  iconName: 'skill-explorer' as IconName,
  icon: [
    768,
    1024,
    [],
    'e991',
    'M576 96c0 53-43 96-96 96s-96-43-96-96 43-96 96-96 96 43 96 96zM486.6 461.4l-38.2 152.6 99.4 99.4c18 18 28.2 42.4 28.2 67.8v178.8c0 35.4-28.6 64-64 64s-64-28.6-64-64v-165.4l-147.8-147.8c-31.6-31.6-44.4-77.2-33.8-120.6l40.8-168c16.6-68.2 85.4-109.8 153.4-92.8 38 9.6 71.2 32.8 92.8 65.4l56.8 85.2h61.8v-48c0-26.6 21.4-48 48-48s48 21.4 48 48v111.6c0 0.2 0 0.4 0 0.4s0 0.4 0 0.4v495.6c0 26.6-21.4 48-48 48s-48-21.4-48-48v-432h-78.8c-32 0-62-16-79.8-42.8l-26.6-40zM162.2 943.8l72.4-275.8c6 8.4 12.8 16.4 20.2 23.8l83.8 83.8-52.8 200.6c-9 34.2-44 54.6-78.2 45.6s-54.6-44-45.6-78.2zM273.2 251.8l-70.4 281.2c-6 24.2-29.8 39.8-54.4 35.8l-95.8-16c-28-4.6-45.8-32.6-38.4-60l49.6-182.8c19-69.6 82.2-118 154.4-118h8.4c31.2 0 54.2 29.4 46.6 59.6z',
  ],
} satisfies IconDefinition;
